import { CustomChip } from '../../../components/chip/Chip';
import { insertColumnAfter, removeColumnByField } from '../../../helpers/tools';
import { colorEstadosChip, colorEstadosCIChip } from './colorsEstados';
import { TIPO_NOTIFICACION_ENUM } from './enumTipoNotificacion';

const columnUsuarioRealizador = {
    flex: 0.0013,
    field: 'profesionalASignado',
    headerName: 'Usuario Realizador'
};

const columnProfesionalAsignado = {
    flex: 0.0013,
    field: 'profesionalASignado',
    headerName: 'Profesional Asignado'
};

export const columnsModel = [
    {
        flex: 0.0009,
        field: 'idEvaluacion',
        headerName: 'Contrato'
    },
    {
        flex: 0.0009,
        field: 'tipoEvaluacion',
        headerName: 'Origen'
    },
    {
        flex: 0.0010,
        field: 'programa',
        headerName: 'Programa'
    },
    {
        flex: 0.0020,
        field: 'cliente',
        headerName: 'Cliente'
    },
    {
        flex: 0.0008,
        field: 'hC',
        headerName: 'HC'
    },
    {
        flex: 0.0025,
        field: 'paciente',
        headerName: 'Paciente'
    },
    {
        flex: 0.0015,
        field: 'estadoCoordinador',
        headerName: 'Estado Coordinador',
        renderCell: ({ row }) => {
            const color = colorEstadosChip[row?.estadoCoordinador];
            return (row?.estadoCoordinador
                ? <CustomChip label={row?.estadoCoordinador} {...color} />
                : <div className='center'>-</div>)
        }
    },
    {
        flex: 0.0013,
        field: 'fechaNotificacion',
        headerName: 'Fecha Notificación',
        type: 'date',
        time: true
    },
    {
        flex: 0.0016,
        field: 'fechaRealizacion',
        headerName: 'Fecha Realización',
        type: 'date',
        time: true
    }
];

export const columnsIndicaciones = insertColumnAfter(columnsModel, columnUsuarioRealizador, 'paciente');

export const columnsPrograma = insertColumnAfter(columnsModel, columnProfesionalAsignado, 'paciente');

export const columnsEquipo = [
    {
        flex: 0.0009,
        field: 'idEvaluacion',
        headerName: 'Contrato'
    },
    {
        flex: 0.0009,
        field: 'tipoEvaluacion',
        headerName: 'Origen'
    },
    {
        flex: 0.0010,
        field: 'programa',
        headerName: 'Programa'
    },
    {
        flex: 0.0020,
        field: 'cliente',
        headerName: 'Cliente'
    },
    {
        flex: 0.0020,
        field: 'tipoNoticacion',
        headerName: 'Tipo Notificación',
        valueGetter: (tipoNoticacion) => (TIPO_NOTIFICACION_ENUM[tipoNoticacion] || '')
    },
    {
        flex: 0.0008,
        field: 'hC',
        headerName: 'HC'
    },
    {
        flex: 0.0025,
        field: 'paciente',
        headerName: 'Paciente'
    },
    {
        flex: 0.0013,
        field: 'estadoCoordinador',
        headerName: 'Estado Confirmar Equipo',
        renderCell: ({ row }) => {
            const color = colorEstadosCIChip[row?.estadoCoordinador];
            return (row?.estadoCoordinador
                ? <CustomChip label={row?.estadoCoordinador} {...color} />
                : <div className='center'>-</div>)
        }
    },
    {
        flex: 0.0013,
        field: 'fechaNotificacion',
        headerName: 'Fecha Notificación',
        type: 'date',
        time: true
    },
    {
        flex: 0.0016,
        field: 'fechaRealizacion',
        headerName: 'Fecha Realización',
        type: 'date',
        time: true
    }
];

export const columnsIndicacionesWithoutFechaRealizacion = removeColumnByField(columnsIndicaciones, 'fechaRealizacion');

export const columnsProgramasWithoutFechaRealizacion = removeColumnByField(columnsPrograma, 'fechaRealizacion');

export const columnsIndicacionesWithoutUsuarioRealizador = removeColumnByField(columnsIndicacionesWithoutFechaRealizacion, 'profesionalASignado');

export const columnsEquipoWithoutFechaRealizacion = removeColumnByField(columnsEquipo, 'fechaRealizacion');